'use client';
import { PropsWithChildren, useEffect, useState } from 'react';
import { useTheme, ThemeProvider } from 'next-themes';
import { ConfigProvider, Spin } from 'antd';
import themes from '@/utils/themes';
import styled from '@emotion/styled';

const LoadingPage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  background: rgba(0, 0, 0, 0.05);
`;

export const ThemesProvider = (props: PropsWithChildren) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return (
      <LoadingPage>
        <Spin />
      </LoadingPage>
    );
  }
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="light"
      enableSystem
      disableTransitionOnChange
    >
      {props.children}
    </ThemeProvider>
  );
};

export const WithThemes = ({ children }: PropsWithChildren) => {
  const [themeSystem, changeSystemTheme] = useState('system');
  const { theme: nowTheme } = useTheme();

  useEffect(() => {
    const media = window.matchMedia('(prefers-color-scheme: dark)');
    media.addEventListener('change', (e) => {
      changeSystemTheme(e.matches ? 'dark' : 'light');
    });
  }, [themeSystem]);

  const themeNow = nowTheme === 'dark' ? themes.darkTheme : themes.lightTheme;
  const colorPrimaryAntd = themeNow.token?.colorPrimary;
  const colorTextSecondaryAntd = themeNow.token?.colorTextSecondary;
  const colorTextAntd = themeNow.token?.colorText;
  const boxShadowAntd = themeNow.token?.boxShadow;
  const colorFillSecondaryAntd = themeNow.token?.colorFillSecondary;
  const colorPrimaryBgHoverAntd = themeNow.token?.colorPrimaryBgHover;
  const stepColor = themeNow.token?.colorBgContainer
  const actionColor = themeNow.token?.colorSuccessBg

  const customStyles = `
  :root {
    --primary-color: ${colorPrimaryAntd};
    --color-text: ${colorTextAntd};
    --color-text-secondary: ${colorTextSecondaryAntd};
    --box-shadow: ${boxShadowAntd};
    --color-bg-container: ${colorFillSecondaryAntd};
    --primary-color-bg-hover: ${colorPrimaryBgHoverAntd};
    --step-bg-color: ${stepColor}; /* For steps */
    --action-bg-color: ${actionColor}; /* For actions */
  }
`;

  return (
    <ConfigProvider theme={themeNow}>
      <style>{customStyles}</style>
      {children}
    </ConfigProvider>
  );
};

